module.exports = __webpack_public_path__ + "img/gateway6.884f07b9.png";